export default __webpack_public_path__ + "static/Billy-Rides-A-Wave-06d6dad5ad76c22a4dd0600a4d4f24ac.mp3";